var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 30,
    viewBox: "0 0 69 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46975 16.4142C0.688705 15.6332 0.688705 14.3668 1.46975 13.5858L14.1977 0.85787C14.9787 0.0768207 16.2451 0.0768206 17.0261 0.857869C17.8071 1.63892 17.8071 2.90525 17.0261 3.6863L5.71239 15L17.0261 26.3137C17.8071 27.0948 17.8071 28.3611 17.0261 29.1421C16.2451 29.9232 14.9787 29.9232 14.1977 29.1421L1.46975 16.4142ZM68.7021 17L2.88396 17L2.88396 13L68.7021 13L68.7021 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconLeft);
export default __webpack_public_path__ + "static/media/arrowIconLeft.0823c02ef99d53943ec678d3c6c6ee51.svg";
export { ForwardRef as ReactComponent };